module.exports = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBwpw8blKNOXQEy2v32SkjFGlCMUpGOMqY",
    authDomain: "field-service-8b8ae.firebaseapp.com",
    databaseURL: "https://field-service-8b8ae.firebaseio.com",
    projectId: "field-service-8b8ae",
    storageBucket: "field-service-8b8ae.appspot.com",
    messagingSenderId: "217038043470",
  },
  // api: "http://10.1.1.183/field-service/api", //PROD
  // api: "http://10.1.50.138:7013/field-service/api", //DEV
  api: "http://10.1.50.113:7013/field-service/api", //HML
  // api: "http://localhost:7001/field-service/api"
};
